import { SidenavUtils } from '@/common/utils/SideNavUtils';
import { far, fas } from '@awesome.me/kit-b4fd369ea4/icons';

const mdSideNav = {
  id: 'md',
  displayName: 'Master Data',
  role: 'MD_VIEW',
  icon: far.faCabinetFiling,
  children: [
    // Organization Menu
    SidenavUtils.orgMenu('md'),

    // Products Section
    {
      id: 'mdProdMenu',
      displayName: 'Product',
      role: 'MD_PROD_VIEW',
      icon: fas.faPills,
      children: [
        { id: 'mdLabeler', displayName: 'Labelers', role: 'MD_LABELER_VIEW', icon: fas.faPills, route: '/md/labeler' },
        { id: 'mdNdc9Prod', displayName: 'NDC9', role: 'MD_NDC9_PROD_VIEW', icon: fas.faPills, route: '/md/ndc9-prod' },
        { id: 'mdSkuProd', displayName: 'SKU', role: 'MD_SKU_PROD_VIEW', icon: fas.faPills, route: '/md/sku-prod' },

        {
          id: 'mdNdc11Prod',
          displayName: 'NDC11',
          role: 'MD_NDC11_PROD_VIEW',
          icon: fas.faPills,
          route: '/md/ndc11-prod',
        },
        {
          id: 'mdMedDeviceProd',
          displayName: 'Medical Devices',
          role: 'MD_MED_DEVICE_PROD_VIEW',
          icon: fas.faPills,
          route: '/md/med-device-prod',
        },
        {
          id: 'mdBrandProd',
          displayName: 'Brands',
          role: 'MD_BRAND_PROD_VIEW',
          icon: fas.faFolderTree,
          route: '/md/brand-prod',
        },
        {
          id: 'mdMarketBasketProd',
          displayName: 'Market Baskets',
          role: 'MD_MARKET_BASKET_PROD_VIEW',
          icon: fas.faFolderTree,
          route: '/md/market-basket-prod',
        },
        {
          id: 'mdMarketShare',
          displayName: 'Market Share',
          role: 'MD_MARKET_SHARE_VIEW',
          icon: fas.faUsdCircle,
          route: '/md/market-share',
        },
        {
          id: 'mdProdSetProd',
          displayName: 'Product Sets',
          role: 'MD_PROD_SET_PROD_VIEW',
          icon: fas.faFolderTree,
          route: '/md/prod-set-prod',
        },
        {
          id: 'mdNdc11ProdUnitThreshold',
          displayName: 'NDC11 Unit Threshold',
          role: 'MD_NDC11_PROD_UNIT_THRESHOLD_VIEW',
          icon: fas.faPills,
          route: '/md/ndc11-prod-unit-threshold',
        },
      ],
    },

    // Customers Section
    {
      id: 'mdCustMenu',
      displayName: 'Customer',
      role: 'MD_CUST_VIEW',
      icon: fas.faUserTag,
      children: [
        { id: 'mdCust', displayName: 'Customers', role: 'MD_CUST_VIEW', icon: fas.faUserTag, route: '/md/cust' },
        { id: 'mdCot', displayName: 'Classes of Trade', role: 'MD_COT_VIEW', icon: fas.faUsersClass, route: '/md/cot' },
        { id: 'mdForm', displayName: 'Formularies', role: 'MD_FORM_VIEW', icon: fas.faBook, route: '/md/form' },
        {
          id: 'mdPharmProdExc',
          displayName: 'Pharmacy/Product Excl.',
          role: 'MD_PHARM_PROD_EXC_VIEW',
          icon: fas.faClinicMedical,
          route: '/md/pharm-prod-exc',
        },
        {
          id: 'mdMcdPharmExc',
          displayName: 'Medicaid Pharmacy Excl.',
          role: 'MD_MCD_PHARM_EXC_VIEW',
          icon: fas.faClinicMedical,
          route: '/md/mcd-pharm-exc',
        },
        {
          id: 'mdBaseline',
          displayName: 'Baselines',
          role: 'MD_BASELINE_VIEW',
          icon: fas.faBook,
          route: '/md/baseline',
        },
      ],
    },

    // Prices Section
    {
      id: 'mdProdPrice',
      displayName: 'Prices',
      role: 'MD_PROD_PRICE_VIEW',
      icon: fas.faUsdCircle,
      route: '/md/prod-price',
    },

    // Contracts Section
    {
      id: 'mdCtrtMenu',
      displayName: 'Contracts',
      role: 'MD_CTRT_VIEW',
      icon: fas.faFileInvoiceDollar,
      route: '/md/ctrt',
    },

    // Filters
    { id: 'mdFilter', displayName: 'Filters', role: 'MD_FILTER_VIEW', icon: fas.faFilter, route: '/md/filter' },

    // Rates
    { id: 'mdRate', displayName: 'Rates', role: 'MD_RATE_VIEW', icon: fas.faChartLine, route: '/md/rate' },

    // Add common menus
    ...SidenavUtils.commonMenus('md'),
  ],
};

export default mdSideNav;
